import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'settings.onboarding.pike13.title',
    defaultMessage: 'Pike13 Integration',
  },
  subdomainTitle: {
    id: 'settings.onboarding.pike13.subdomain-title',
    defaultMessage: 'Pike13 subdomain',
  },
  subdomainDesc: {
    id: 'settings.onboarding.pike13.subdomain-desc',
    defaultMessage: 'Please enter the Pike13 subdomain associated with this ClassPass venue.',
  },
  transitionDateTitle: {
    id: 'settings.onboarding.pike13.transition-date-title',
    defaultMessage: 'Select transition date',
  },
  transitionDateDesc1: {
    id: 'settings.onboarding.pike13.transition-date-desc1',
    defaultMessage: 'Please select the date on which you would like to transition to Pike13.',
  },
  transitionDateDesc2: {
    id: 'settings.onboarding.pike13.transition-date-desc2',
    defaultMessage: 'You will be unable to change existing schedules before this date once the transition is complete.',
  },
  locationIdTitle: {
    id: 'settings.onboarding.pike13.locationid-title',
    defaultMessage: 'Select location',
  },
  locationIdDesc: {
    id: 'settings.onboarding.pike13.locationid-desc',
    defaultMessage: 'Please select location to migrate:',
  },
  classIdsTitle: {
    id: 'settings.onboarding.pike13.classids-title',
    defaultMessage: 'Select Sessions',
  },
  classIdsDesc1: {
    id: 'settings.onboarding.pike13.classids-desc1',
    defaultMessage: 'Select which sessions you want to make available on ClassPass.',
  },
  classIdsDesc2: {
    id: 'settings.onboarding.pike13.classids-desc2',
    defaultMessage: 'You can always change or add to your selections at a later date.',
  },
  authorizeTitle: {
    id: 'settings.onboarding.pike13.authorize-title',
    defaultMessage: 'Authorize ClassPass',
  },
  authorizeDesc: {
    id: 'settings.onboarding.pike13.authorize-desc',
    defaultMessage: 'The last step is give ClassPass access.',
  },
  authorizeButton: {
    id: 'settings.onboarding.pike13.authorize-button',
    defaultMessage: 'Authorize ClassPass',
  },
  ineligibleVenue: {
    id: 'settings.onboarding.pike13.ineligible-venue',
    defaultMessage: 'The selected venue can not be migrated to Pike13.',
  },
  invalidSubdomain: {
    id: 'settings.onboarding.pike13.invalid-subdomain',
    defaultMessage: '"{subdomain}" is not a valid Pike13 organization name.',
  },
  integrationError: {
    id: 'settings.onboarding.pike13.integration-error',
    defaultMessage: 'The integration failed. Please contact your account manager.',
  },
  integrationSuccess: {
    id: 'settings.onboarding.pike13.integration-success',
    defaultMessage: 'Congratulations! Your integration is complete.',
  },
});

export default messages;
